/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import {
    func, shape, string, bool,
} from 'prop-types';
import AddressBookWithPagination from '../../../../../../pages/Checkout/containers/CheckoutFloral/Partials/AddressBookWidget/AddressBookWithPagination';
import { withAuth } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import {
    getAddressBookEntries,
    getAddressBookPageNumber,
    getTotalEntriesAddressBook,
    getTotalNoOfPages,
    getIsAuthenticatedStatus,
    getIsWriteScopeCheckout,
    getUserType,
} from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import {
    clearUserSubmittedProductFilterZipcode,
    setLocationType, setProductFilterZipcodeValidity, setUserSelectedAddress, setUserSubmittedProductFilterZipcode, setValidatedZipcode,
} from '../../../../../../../state/ducks/App/App-Actions';
import { getUserSubmittedProductFilterZipcode } from '../../../../../../../state/ducks/Common/Common-Selectors';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { loadAddressBook, removeAddressBook } from '../../../../../../../state/ducks/Member/ducks/AddressBook/AddressBook-Actions';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '@media screen and (max-width: 1020px)': {
            width: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '14px',
        },
    },
    paperHeaderLink: {
        fontSize: '16px',
        lineHeight: '21px',
        padding: '0px 16px 0px 0px',
        color: '#ffffff',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '@media screen and (max-width: 1020px)': {
            paddingRight: '0px',
        },
        '& strong': {
            paddingLeft: '8px',
        },
    },
}));
const GiftFinderLoginPrompt = ({
    auth, textColor, handleChange, giftFinderLoginEnabled,
}) => {
    const classes = useStyles();

    // const [zipField, setZipField] = useState('');

    const isAuthenticated = useSelector(getIsAuthenticatedStatus);
    const isWriteScopeCheckout = useSelector(getIsWriteScopeCheckout);
    const userSubmittedZip = useSelector(getUserSubmittedProductFilterZipcode);
    const totalAddresses = useSelector(getTotalEntriesAddressBook);
    const addressBookEntries = useSelector(getAddressBookEntries);
    const addressBookPageOn = useSelector(getAddressBookPageNumber);
    const addressBookTotalPages = useSelector(getTotalNoOfPages);
    const userType = useSelector(getUserType);
    const featureFlags = useSelector(getFeatureFlags);
    const dispatch = useDispatch();

    useEffect(() => {
        if (userType === 'R' && isWriteScopeCheckout) {
            dispatch(loadAddressBook());
        }
    }, [userType, isWriteScopeCheckout]); // only runs when either changes

    const handleSelectedAddressBook = (data) => {
        if (userSubmittedZip) {
            dispatch(clearUserSubmittedProductFilterZipcode());
        }
        const addressComponents = data?.Addresses[0] || {};
        const postalCode = (addressComponents.PostalCode) ? addressComponents.PostalCode.split('-')[0] : '';

        dispatch(setLocationType(addressComponents?.AddressType || 'Residence'));
        addressComponents.EmployerName = data?.EmployerName || '';
        addressComponents.FirstName = data?.FirstName || '';
        addressComponents.LastName = data?.LastName || '';
        if (data?.PhoneNumber) {
            addressComponents.PhoneNumber = data.PhoneNumber;
        }
        // setZipField(postalCode);
        dispatch(setValidatedZipcode(postalCode));
        dispatch(setProductFilterZipcodeValidity(true));
        dispatch(setUserSubmittedProductFilterZipcode(postalCode?.trimEnd()));

        const event = {
            target: {
                value: postalCode?.trimEnd(),
            },
        };
        handleChange('zip')(event);

        const reduxAddress = {
            addressComponents,
            addressSource: 'pdpAddressBook',
        };
        dispatch(setUserSelectedAddress(reduxAddress));
    };

    // had to add from DeliveryForm.js
    const handleRemoveAddressBook = (addressBookEntryId) => {
        if (userType === 'R' && addressBookEntryId) {
            dispatch(removeAddressBook(addressBookEntryId));
        }
    };
    const callLoadAddressBook = (value) => {
        dispatch(loadAddressBook(value));
    };
    const iconContact = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <g clip-path="url(#clip0_297_9076)">
                <path d="M17.5 21V19C17.5 17.9391 17.0786 16.9217 16.3284 16.1716C15.5783 15.4214 14.5609 15 13.5 15H5.5C4.43913 15 3.42172 15.4214 2.67157 16.1716C1.92143 16.9217 1.5 17.9391 1.5 19V21" stroke={textColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.5 11C11.7091 11 13.5 9.20914 13.5 7C13.5 4.79086 11.7091 3 9.5 3C7.29086 3 5.5 4.79086 5.5 7C5.5 9.20914 7.29086 11 9.5 11Z" stroke={textColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M23.5 21V19C23.4993 18.1137 23.2044 17.2528 22.6614 16.5523C22.1184 15.8519 21.3581 15.3516 20.5 15.13" stroke={textColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.5 3.13C17.3604 3.35031 18.123 3.85071 18.6676 4.55232C19.2122 5.25392 19.5078 6.11683 19.5078 7.005C19.5078 7.89317 19.2122 8.75608 18.6676 9.45769C18.123 10.1593 17.3604 10.6597 16.5 10.88" stroke={textColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_297_9076">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
    return (
        <div className={classes.root}>
            {!isAuthenticated && (
                <div
                    className={classes.paperHeaderLink}
                    role="button"
                    tabIndex={-1}
                    style={{ color: textColor }}
                    onKeyDown={() => { }}
                    onClick={async () => {
                        dispatch(trackEvent({
                            eventCategory: 'Gift Finder',
                            eventAction: 'Sign in for your contacts',
                            eventLabel: 'Gift Finder Login Prompt',
                            feature_detail: 'Gift Finder Login Prompt',
                            feature_element: 'Sign in for your contacts',
                            feature_category: 'Gift Finder',
                        }));

                        await auth.loginByRedirect();
                    }}
                    data-test="pdp-address-book"
                    id="address-book-signin"
                    name="pdpSignin"
                >
                    {iconContact()} <strong>Sign in for your Contacts</strong>
                </div>
            )}
            {
                isAuthenticated && isWriteScopeCheckout && (
                    <AddressBookWithPagination
                        name="pdpAddressBook"
                        entries={addressBookEntries}
                        onSelectedAddress={handleSelectedAddressBook}
                        loadAddressBook={callLoadAddressBook}
                        handleRemoveAddressBook={handleRemoveAddressBook}
                        handleChangeAddressBook={() => { }}
                        pageOn={addressBookPageOn}
                        noOfPages={addressBookTotalPages}
                        totalAddresses={totalAddresses}
                        isAccessBasedOnScopeEnabled={featureFlags['is-access-based-on-scope-enabled']}
                        pageType="pdp"
                        label="My Contacts"
                        iconLogin={iconContact}
                        isEnableLoginPrompt={giftFinderLoginEnabled}
                        textColor={textColor}
                    />
                )
            }
        </div>
    );
};

GiftFinderLoginPrompt.propTypes = {
    auth: shape({
        loginByRedirect: func.isRequired,
    }).isRequired,
    textColor: string.isRequired,
    handleChange: func.isRequired,
    giftFinderLoginEnabled: bool.isRequired,
};

export default withAuth(GiftFinderLoginPrompt);
